<template>
    <div class="parent">
        <div class="router">
            <div class="current-address"><b><u>{{address}}</u></b></div>
            <router-link :to="{name: 'search'}" class="rtrsearch">
                <small>Search Another Address</small>
            </router-link>

        </div>
        <div class="calendar-parent">
            <calendar-view
                    :show-date="showDate"
                    display-period-uom="month"
                    useTodayIcons="true"
                    :display-period-count="1"
                    :current-period-label="showDate.toLocaleString('en-US', {weekday: 'long', day: 'numeric', month: 'long'})"
                    :events="items"
                    @input="setShowDate"
                    class="theme-default calevent">
                <calendar-view-header
                        id="calview"
                        slot="header"
                        slot-scope="t"
                        :header-props="t.headerProps"
                        @input="setShowDate"/>
            </calendar-view>

        </div>
    </div>
</template>

<script>
    import {CalendarView, CalendarViewHeader} from "vue-simple-calendar"
    import {AXIOS}                            from "../services/main";
    import {COLORMAP}                         from "../services/main";
    import * as moment                        from 'moment';

    export default {
        props: {dataset: {type: String}, company: {type: String}, customer: {type: Number}, address: {type:String}},
        name: "SimpleCalendar",
        data() {
            return {
                today: new Date(),
                showDate: new Date(),
                items: [],
                legend: [],
                legendStyle: {
                    color: 'white',
                    padding: '3px',
                    'border-radius': '5px',
                }
            }
        },
        components: {
            CalendarView,
            CalendarViewHeader,
        },
        created() {
            this.fetchData()
        },
        watch: {
            '$route': 'fetchData'
        },
        methods: {
            fetchData() {
                this.error = this.post = null;
                this.loading = true;
                const url = '/PickupCalendar/' + this.dataset + '/calendar?';
                const query = 'customer=' + this.$route.params.customer + '&company=' + this.$route.params.company;
                AXIOS.get(url + query)
                     .then(response => {
                         this.data = response.data;
                         this.items = buildlist(response);
                     }).catch(e => {
                    this.errors.push(e)
                });
            }, setShowDate(d) {
                this.showDate = d;
            }
        }, computed: {}
    }

    function buildlist(response) {
        let holidayList = response.data['webHolidayList'];
        let pickupList = response.data['servicePickupList'];
        let pickupmap = new Map();
        let holidayDelay = 0;
        let events = [];
        let isHoliday = [];
        let holidayWeekDates = new Map();

        if (pickupList.length > 0) {
            holidayDelay = pickupList[0]['holidayDelay'];
        }
        // build map of pickups w/ styling
        for (let x in holidayList) {
            let holiday = holidayList[x]['date'];
            // Add Holiday date objects within the max history
            if (withinMaxHistory(holiday)) {
                isHoliday.push(new moment(holiday).toDate().toString());
                let holidayadjMap = getHolidayAdjustment(holiday, holidayDelay);
                setMapElements(holidayadjMap, holidayWeekDates);
                events.push({
                    id: 'holiday' + x,
                    startDate: holidayList[x]['date'],
                    classes: "holidays calevent",
                    title: 'Holiday',
                    style: styleObj(COLORMAP.get('indigo'))
                })
            }
        }
        for (let x in pickupList) {
            let color = pickupList[x]['color'].toLowerCase();
            let type = pickupList[x]['type'];
            let desc = pickupList[x]['typeDescription'];
            let interv = pickupList[x]['daysInterval'];
            if (pickupmap.has(type)) {
                let result = pickupmap.get(type);
                let keyColor = result['color'];
                let keyDates = result['dates'];
                if (keyDates.indexOf(pickupList[x]['pickupDate']) === -1) {
                    keyDates.push(pickupList[x]['pickupDate']);
                }
                pickupmap.set(type, {description: desc, color: keyColor, dates: keyDates, interval: interv});
            } else {
                // always assign a color for map, even if one is not provided
                if (!color.startsWith('#')) {
                    if (COLORMAP.has(color)) {
                        color = COLORMAP.get(color);
                    } else {
                        color = COLORMAP[Math.floor(Math.random() * 12)]
                    }
                }
                pickupmap.set(type, {description: desc, color: color, dates: [pickupList[x]['pickupDate']], interval: interv});
            }
        }
        let ctr = 0;

        for (const [k, v] of pickupmap) {
            let useColor = v.color;
            let interv = v.interval;
            let dateslist = buildAdditionalPickups(v.dates, interv);
            for (const idx in dateslist) {
                let date = dateslist[idx];
                if (holidayWeekDates.has(date.toString()) === true) {
                    date = holidayWeekDates.get(date.toString());
                }
                events.push({
                    id: 'dt' + ctr,
                    startDate: date,
                    classes: "calevent",
                    style: styleObj(useColor),
                    title: v.description
                });
                ctr++;
            }
        }
        return events;
    }

    // Build past and future stops for given interval, (7 * 12) days
    function buildAdditionalPickups(datelist, interval) {
        let list = [];
        for (let i in datelist) {
            let x = interval > 7 ? 6 : 12;

            for (let k = 1; k < x; k++) {
                let subDays = interval * k;
                let dt = new moment(datelist[i]);
                let newDt = dt.subtract(subDays, 'd');
                list.push(newDt.toDate());
            }

            for (let j = 0; j < x; j++) {
                let addDays = interval * j;
                let dt = new moment(datelist[i]);
                let newDt = dt.add(addDays, 'd');
                list.push(newDt.toDate());
            }
        }
        return list;
    }

    function withinMaxHistory(date) {
        const nowDate = new moment(new Date());
        let dt = new moment(date);
        return dt > nowDate.subtract(90, 'd');
    }

    // Map containing adjusted holiday pickups
    function getHolidayAdjustment(holiday, delay) {
        let adjustMap = new Map();
        if (delay !== 0) {
            let varholiday = new Date(holiday);
            let dt = new moment(holiday);
            let wkday = varholiday.getDay();

            if (delay > 0 && wkday !== 6) {
                adjustMap.set(dt.toDate(), dt.add(delay, 'd').toDate());
                for (let x = 0; wkday < 6; wkday++) {
                    let adjdate = dt.add(x, 'd');
                    let before = adjdate.toDate();
                    adjdate.add(delay, 'd');
                    let after = adjdate.toDate();
                    adjustMap.set(before, after);
                }
            }

            if (delay < 0 && wkday !== 0) {
                adjustMap.set(dt.toDate(), dt.add(delay, 'd').toDate());
                for (let x = 0; wkday > 1; wkday--) {
                    let adjdate = dt.subtract(x, 'd');
                    let before = adjdate.toDate();
                    adjdate.add(delay, 'd');
                    let after = adjdate.toDate();
                    adjustMap.set(before, after);
                }
            }
        }
        return adjustMap;
    }

    function setMapElements(map1, map2) {
        for (const [k, v] of map1) {
            map2.set(k.toString(), v);
        }
    }

    // Style dates when added to events
    function styleObj(color) {
        return "backgroundColor :" + color + "; color: white; border-radius: 5px";
    }
</script>

<style scoped lang="scss">
    .parent {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        color: #2c3e50;
        height: 100vh;
        width: 90vw;
        margin-left: auto;
        margin-right: auto;
        background-color: aliceblue;
    }
    .current-address{
        font-size: large;
    }

    .calendar-parent {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        color: #2c3e50;
        height: 96vh;
        width: 90vw;
        margin-left: auto;
        margin-right: auto;
        background-color: white;
    }

    #calview {
        border: 2px;
        background-color: #F2F2F2;
    }

    .rtrsearch {
        color: #2c3e50;
        display: inline-block;
        border: 1px solid darkgray;
        border-radius: 4px;
        padding-left: 4px;
        padding-right: 4px;
        background-color: #F2F2F2;
        line-height: 16px;
    }

    .router {
        background-color: #DDDDDD;
        margin-left: auto;
        margin-right: auto;
        text-align: left;
        padding-bottom: 3px;
        padding-left: 12px;
    }

    .calevent {
        border-radius: 5px;
        color: black;
    }

</style>